import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventCategory, GaTrackingEventName, GATrackingEventType } from '../../constants';

export class GATrackingPDPOfferPriceSyncIssueEvent implements GATrackingEvent {
  constructor(private payload: any) {}

  getEventType(): any {
    return GATrackingEventType.OfferPriceSyncIssue;
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: GaTrackingEventName.OfferPriceSync,
      label: this.payload.label,
      gtmCustom: {
        category: GaTrackingEventCategory.Errors
      }
    };
  }
}
